<div class="container" [class.horizontal]="layout() === 'horizontal'">


  @if(showConnections()) {
  <div class="connection">
    <small>{{topConnection() ?? $legacyPart()?.topConnection}}</small>
  </div>
  }

  @if(partNumber() && width() && height()) {
  <img [src]="imageUrl" [width]="width()" [height]="height()"
    [style.width.px]="width()" [style.height.px]="height()"
    onerror="javascript:this.src='assets/icons/icon-64x64.png'">
  }


  @if(showConnections()) {
  <div class="connection">
    <small>{{bottomConnection() ?? $legacyPart()?.bottomConnection}}</small>
  </div>
  }


</div>
